"use client";

import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import IconSlider from "@/components/IconSlider";

const Hero = () => {
  return (
    <section className="min-h-screen flex flex-col justify-center pt-24 pb-16 px-6">
      <div className="container max-w-6xl mx-auto">
        <div className="flex flex-col md:flex-row gap-6">
          {/* Main Content */}
          <div className="flex-1 animate-fade-in">
            <span className="text-sm md:text-base text-accent font-medium mb-4 block">
              Aqdas Malik
            </span>
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight md:leading-tight lg:leading-tight max-w-4xl mb-6">
              <span className="text-gradient">AI Expert & Automation Engineer</span> crafting intelligent solutions.
            </h1>
            <p className="text-xl md:text-2xl text-muted-foreground max-w-2xl mb-10 leading-relaxed">
              Shipping production-grade AI & automation, from zero to millions
            </p>
            <div className="flex flex-col sm:flex-row gap-4 items-start sm:items-center">
              <Button 
                size="lg" 
                className="group text-base px-6 rounded-full"
                onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}
              >
                Book a Call
                <ArrowRight 
                  size={18} 
                  className={cn(
                    "ml-2 transition-transform duration-300",
                    "group-hover:translate-x-1"
                  )}
                />
              </Button>
              <Button 
                variant="outline" 
                size="lg"
                className="text-base px-6 rounded-full"
                asChild
              >
                <a href="#projects">See my work</a>
              </Button>
            </div>
          </div>

          {/* Icon Slider - only visible on md screens and above */}
            <IconSlider className="h-[500px] hidden md:block w-[100px] lg:w-[130px]" size="large" />
            <IconSlider className="h-[500px] hidden md:block w-[60px] lg:w-[70px]" size="medium" />
            <IconSlider className="h-[500px] hidden lg:block w-[35px] lg:w-[40px]" size="small" />
        </div>
      </div>
    </section>
  );
};

export default Hero;
